export const LOADING_MESSAGES = [
  'Verifying the verifiers...',
  'Fact-checking the fact-checkers...',
  'Separating facts from fiction...',
  'Consulting primary sources...',
  'Truth loading, please stand by...',
  'Calibrating the BS detector...',
  'Asking the real questions...',
  'Following the paper trail...',
  'Cross-referencing everything...',
  'No cap, just facts...',
  'Making misinformation nervous...',
  "Doing the research so you don't have to...",
  'Sifting through the noise...',
  'Trust, but verify. Verifying now...',
  'Powered by curiosity and citations...',
  'Where receipts meet research...',
  'Loading unbiased bytes...',
  "Facts don't care about loading times...",
  'Brewing some truth serum...',
  "Sharpening Occam's Razor..."
];
